module.exports = __webpack_public_path__ + "static/media/18ECA44.de61f19c.jpg";